<template>
  <zl-dialog class="zl-saas" title="延长报价" ref="dialog" width="960px">
    <div>
      <el-form :model="form" label-width="150px" ref="ruleForm" :rules="rules">
        <el-form-item label="报价截止时间：">
          <el-date-picker
            v-model="inquireForm.endTime"
            type="datetime"
            value-format="timestamp"
            disabled
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="newEndTime" label="延长报价截止时间：">
          <el-date-picker
            v-model="form.newEndTime"
            type="datetime"
            placeholder="设置报价截止时间"
            value-format="timestamp"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <!-- <el-table class="m-b" :data="supplierList">
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column
          label="供应商名称"
          prop="supplierName"
        ></el-table-column>
        <el-table-column
          label="报价状态"
          :formatter="formatter1"
        ></el-table-column>
        <el-table-column
          label="报价时间"
          :formatter="formatter2"
        ></el-table-column>
      </el-table> -->
      <baoJiaTable :inquireId="inquireId" v-if="inquireId"></baoJiaTable>
      <span v-if="isOpenApproval" class="saas-card-header-name">设置审批</span>
      <approve v-if="isOpenApproval" :flowType="flowType" ref="approve" :unionId="inquireId" />
    </div>
    <template slot="footer">
      <el-button size="small" plain type="primary" @click="cancel">
        取消
      </el-button>
      <el-button size="small" type="primary" @click="confirm">确定</el-button>
    </template>
  </zl-dialog>
</template>

<script>
import store from '@/store'
import approve from '@/components/business/approve.vue'
import baoJiaTable from '../component/baoJiaTable.vue'
import dayjs from 'dayjs'
export default {
  components: {
    approve,
    baoJiaTable
  },
  data() {
    return {
      isOpenApproval: false,
      inquireId: '',
      form: {
        newEndTime: ''
      },
      inquireForm: {},
      // supplierList: [],
      rules: {
        newEndTime: [
          { required: true, message: '请输入截止时间', trigger: 'blur' }
        ]
      },
      flowType: 21
    }
  },
  computed: {
    // 是否小额采购
    isSmallScaleProcurement() {
      return store.state.isSmallScaleProcurement
    }
  },
  methods: {
    open(args) {
      this.flowType = this.isSmallScaleProcurement ? 2188 : 21
      this.inquireId = args.inquireId
      store
        .dispatch('getFirstInquireStep', {
          id: this.inquireId
        })
        .then((res) => {
          console.log(res)
          this.inquireForm = {
            ...res,
            endTime: dayjs(res.endTime),
            deliveryTime: dayjs(res.deliveryTime)
          }
          this.$emit('update:projectId', res.projectId)
        })
      // store
      //   .dispatch('listSupplierByInquireId', {
      //     inquireId: args.inquireId
      //   })
      //   .then((res) => {
      //     this.supplierList = res
      //   })
      store
        .dispatch('approvalIsOpen', {
          flowType: this.flowType
        })
        .then((res) => {
          this.isOpenApproval = res
        })
      return this.$refs.dialog.open()
    },
    cancel() {
      this.$refs.dialog.cancel()
    },
    confirm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          store
            .dispatch('prolongInquire', {
              newEndTime: this.form.newEndTime,
              submitDTO: {
                ...(this.isOpenApproval ? this.$refs.approve.getParmas() : {}),
                submit: true,
                id: this.inquireId
              }
            })
            .then(() => {
              this.$zl.message.success('提交成功')
              this.$refs.dialog.close()
            })
        }
      })
    },
    // formatter1(row) {
    //   return row.quote ? '已报价' : '未报价'
    // },
    // formatter2(row) {
    //   return row.quoteTime && dayjs(row.quoteTime).format('YYYY-MM-DD HH:mm:ss')
    // },
    checkDetail() {}
  }
}
</script>

<style>
.zs-select-deal-supplier-label {
  font-weight: bold;
}
</style>
